// modalSignal.js
import { signal } from "@preact/signals-react";

export const mobileViewSignalUrl = signal("");

export const openMobileView = (url: string) => {
  // console.log("## signal", url);
  mobileViewSignalUrl.value = url;
};

export const closeMobileView = () => {
  mobileViewSignalUrl.value = "";
};
